var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1008,
    height: 21,
    viewBox: "0 0 1008 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19.0254C44.3099 21.1236 88.5044 20.6009 131.063 18.7946C180.88 16.6802 228.477 12.8057 271.404 9.31127L271.404 9.31124L271.423 9.30968C274.82 9.03318 278.187 8.75907 281.524 8.4884C327.056 4.79511 366.889 1.74565 398.021 2.01678C449.006 2.46083 509.683 6.74432 569.797 10.988C583.174 11.9324 596.524 12.8748 609.733 13.7725C682.247 18.7008 750.554 22.2849 795.729 17.396C875.677 8.74422 928.472 7.83161 961.262 9.07762C977.657 9.70061 989.049 10.8632 996.332 11.8672C999.973 12.3693 1002.59 12.8317 1004.28 13.1671C1005.13 13.3348 1005.75 13.4708 1006.16 13.5642C1006.28 13.5911 1006.38 13.6145 1006.46 13.6341C1006.52 13.6484 1006.57 13.6607 1006.61 13.6708C1006.66 13.6828 1006.69 13.6918 1006.71 13.6976L1006.74 13.7039L1006.74 13.7052C1006.74 13.7053 1006.74 13.7053 1006.82 13.4193L1007 12.7387C1007.26 11.7722 1007.26 11.772 1007.26 11.7718L1007.25 11.7711L1007.24 11.7687L1007.21 11.7603C1007.18 11.7531 1007.14 11.7427 1007.09 11.7294C1006.98 11.7028 1006.82 11.6643 1006.61 11.6152C1006.18 11.5171 1005.54 11.3767 1004.67 11.205C1002.93 10.8617 1000.28 10.393 996.605 9.88599C989.25 8.87194 977.792 7.70428 961.338 7.07906C928.432 5.82865 875.538 6.74759 795.514 15.4076C750.548 20.2738 682.43 16.7086 609.868 11.7771C596.675 10.8805 583.335 9.93872 569.964 8.99475C509.849 4.75076 449.092 0.461497 398.038 0.0168556C366.799 -0.255214 326.87 2.80362 281.362 6.49494C278.02 6.76603 274.648 7.04054 271.247 7.31741L271.246 7.31745C228.314 10.8122 180.754 14.6837 130.978 16.7964C88.4184 18.6027 44.2544 19.1222 0 17.023V19.0254Z",
    fill: "url(#paint0_linear_239_15243)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_239_15243",
    x1: 174.5,
    y1: 3.13364e-7,
    x2: 1324.29,
    y2: 0.000239408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF59F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#CA59FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#AE72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#90E9ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651685,
    stopColor: "#5CD167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "#FFEE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FFEE00",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradient);
export default __webpack_public_path__ + "static/media/gradient.7ed162b29638cb5202b7748202eb603c.svg";
export { ForwardRef as ReactComponent };